import React from 'react'
import newsletterConfig from '../../../newsletter-config.json'
import wrappedPropsToJs from '../../../functions/wrappedPropsToJs'
import HtmlNewsletter from "../present/HtmlNewsletter"
import getFontFacesStyles from '../functions/getFontFacesStyles'
import getNewsletterTitle from '../functions/getNewsletterTitle'
import getNewsletterData from '../functions/getNewsletterData'


const NewsletterHtmlContainer = props => {
    const data = wrappedPropsToJs(props)
    const { themeData, logoData, campaign, cinemasData, addressData, week, weeks, newsletterData, ads, highlights, movieData, closingTextLines, translation, imageItems, textItems, socialMediaData, currentCinemaUrl, routesData} = data
    const { cinemaData, stylesData, structureData, theme } = getNewsletterData(logoData, campaign, themeData, cinemasData, addressData, translation, week, weeks, routesData)
    const stylesFontFaces = getFontFacesStyles(cinemaData.cinemaUrl, newsletterConfig.fontConfig[theme] ? newsletterConfig.fontConfig[theme] : [])

    return (
        <HtmlNewsletter
            title={getNewsletterTitle(cinemaData)}
            stylesData={stylesData}
            structureData={structureData}
            cinemaData={cinemaData}
            newsletterData={newsletterData}
            imageItems={imageItems}
            textItems={textItems}
            socialMediaData={socialMediaData}
            currentCinemaUrl={currentCinemaUrl}
            ads={ads}
            highlights={highlights}
            movieData={movieData}
            stylesFontFaces={stylesFontFaces}
            closingTextLines={closingTextLines} 
            translation={translation}
        />
    )
}

export default NewsletterHtmlContainer
